export default __webpack_public_path__ + "static/media/cfx-cm-receipt.2dbac7b4.svg";